import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from "@mui/material";
import { useState, useEffect } from "react";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";

export default function CollaborateurModal({ open, onClose, onSave, initialData, roles = [] }) {
  const [form, setForm] = useState({ nom: "", prenom: "", email: "", password: "", role: "" });
  const [errors, setErrors] = useState({ password: "" });

  useEffect(() => {
    if (initialData) {
      setForm({
        nom: initialData.nom || "",
        prenom: initialData.prenom || "",
        email: initialData.email || "",
        password: "",
        role: initialData.role || "",
      });
      setErrors({ password: "" });
    } else {
      setForm({ nom: "", prenom: "", email: "", password: "", role: "" });
      setErrors({ password: "" });
    }
  }, [initialData, open]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    if (e.target.name === "password") {
      setErrors({ ...errors, password: "" });
    }
  };

  const handleSubmit = () => {
    if (!initialData && !form.password) {
      setErrors({ ...errors, password: "Le mot de passe est requis pour la création." });
      return;
    }
    onSave(form);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ pb: 2 }}>{initialData ? "Modifier" : "Ajouter"} un collaborateur</DialogTitle>
      <DialogContent sx={{ pt: 3, pb: 2 }}>
        <TextField
          margin="dense"
          label="Nom"
          name="nom"
          value={form.nom}
          onChange={handleChange}
          fullWidth
        />
        <TextField
          margin="dense"
          label="Prénom"
          name="prenom"
          value={form.prenom}
          onChange={handleChange}
          fullWidth
        />
        <TextField
          margin="dense"
          label="Email"
          name="email"
          type="email"
          value={form.email}
          onChange={handleChange}
          fullWidth
        />
        <FormControl fullWidth margin="dense">
          <InputLabel id="role-label">Rôle</InputLabel>
          <Select
            labelId="role-label"
            label="Rôle"
            name="role"
            value={form.role}
            onChange={handleChange}
          >
            {roles.map((r) => (
              <MenuItem key={r.id} value={String(r.id)}>{r.libelle || r.id}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          margin="dense"
          label="Mot de passe"
          name="password"
          type="password"
          value={form.password}
          onChange={handleChange}
          fullWidth
          required={!initialData}
          error={Boolean(errors.password)}
          helperText={errors.password || (initialData ? "Laisser vide pour ne pas changer" : "")}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Annuler</Button>
        <Button onClick={handleSubmit} variant="contained">
          {initialData ? "Modifier" : "Ajouter"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}